import { useState } from 'react';

import TituloSessao from '../componentes/TituloSessao';
import SelectTipoRelatorioControlled from '../componentes/SelectTipoRelatorioControlled';
import SelectMetricaIndicadorControlled from '../componentes/SelectMetricaIndicadorControlled';
import InputMes from '../componentes/renderizacaoDinamica/InputMes/index.js'

import { geraRelatorioNovo } from '../servicos/servicosEmRotasPrivadas/relatorios';
import { relatorioConfig } from '../config/reportsConfigParametros.js';

import toast from 'react-hot-toast';

function GerarRelatorios() {

    console.log(' #### Iniciando GerarRelatorios ####');

    let config = null;

    // TESTES DE RENDERIZAÇÃO DINÂMICA DE FILTROS

    const [formData, setFormData] = useState({
        codigoRelatorio: null,
        tipoFiltro: null,
        mesReferencia: null,
        mesInicio: null,
        mesFinal: null,
        metricaId: null,
        downloadFile: true
    });

    console.log(formData);


    if (formData.codigoRelatorio) {
        config = relatorioConfig[formData.codigoRelatorio];
    }

    const componentMap = {
        mes: InputMes,
        select: SelectMetricaIndicadorControlled
    };

    function handleChange(field, value) {
        console.log(field, value);

        setFormData(prev => ({
            ...prev,
            [field]: value
        }))
    };

    function handleChangeTipoRelatório(tipoRelatorioSelecionado) {
        setFormData(prev => ({
            ...prev,
            codigoRelatorio: tipoRelatorioSelecionado.codigo,
            tipoFiltro: tipoRelatorioSelecionado.tipo_filtro
        }))
    };

    // FIM -- TESTES DE RENDERIZAÇÃO DINÂMICA DE FILTROS -- FIM

    async function handlerSubmit(event) {

        event.preventDefault()

        if (formData.codigoRelatorio) {
            try {
                geraRelatorioNovo(formData)
            } catch (error) {
                console.error(error);
                toast.error(error.message)
            }
        } else {
            toast.error('Selecione o tipo de relatório desejado')
        }
    }

    return (
        <div className='container'>
            <TituloSessao titulo='Gerar Relatórios' barraDecorativa={false} />
            <form className='d-flex flex-column div-com-borda p-3 gap-2' onSubmit={handlerSubmit}>
                <div className='d-flex flex-column gap-2'>
                    <label>Tipo de Relatório</label>
                    <SelectTipoRelatorioControlled
                        id='select-tipo-relatorio'
                        value={formData.codigoRelatorio}
                        onChange={(tipoRelatorioSelecionado) => handleChangeTipoRelatório(tipoRelatorioSelecionado)}
                    />
                </div>
                {formData.codigoRelatorio &&
                    <div className='d-flex flex-column gap-2' onSubmit={handlerSubmit}>

                        <div className='d-flex gap-2'>
                            {config &&
                                config.toRender.map((field) => {
                                    const Component = componentMap[field.type];
                                    return (
                                        <div key={field.name} className=''>
                                            <label htmlFor={field.name}>
                                                {field.label}
                                            </label>
                                            <Component
                                                key={field.name}
                                                label={field.label}
                                                name={field.name}
                                                value={formData[field.name]}
                                                onChange={(value) => handleChange(field.name, value)}
                                            />
                                        </div>
                                    );
                                })}
                        </div>

                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="downloadFile"
                                name="downloadFile"
                                checked={formData.downloadFile}
                                onChange={(e) => handleChange('downloadFile', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="downloadFile">
                                Baixar Relatório
                            </label>
                        </div>
                    </div>
                }
                <button className='btn btn-primary' type='submit'>GERAR</button>
            </form>
        </div>
    );
}

export default GerarRelatorios
